/*
  Proyecto FÉNIX — v69.17
  Feedback visual seguro para producto señalado en colecciones móviles.
  No bloquea navegación, no previene clicks, no usa loops ni observers.
*/
(function(){
  'use strict';

  function isMobile(){
    return window.matchMedia && window.matchMedia('(max-width: 767px)').matches;
  }

  function getCollectionItem(target){
    if (!target || !target.closest || !document.body.classList.contains('template-collection')) return null;
    return target.closest('.list-view__product, .grid-uniform.grid-link__container > .grid__item');
  }

  function clearSelected(except){
    var items = document.querySelectorAll('.nm-card-is-selected, .nm-list-is-selected');
    items.forEach(function(item){
      if (item !== except) {
        item.classList.remove('nm-card-is-selected');
        item.classList.remove('nm-list-is-selected');
      }
    });
  }

  function markSelected(event){
    if (!isMobile()) return;
    var item = getCollectionItem(event.target);
    if (!item) return;

    clearSelected(item);

    if (item.classList.contains('list-view__product')) {
      item.classList.add('nm-list-is-selected');
    } else {
      item.classList.add('nm-card-is-selected');
    }

    window.setTimeout(function(){
      item.classList.remove('nm-card-is-selected');
      item.classList.remove('nm-list-is-selected');
    }, 2400);
  }

  document.addEventListener('pointerdown', markSelected, { capture:true, passive:true });
})();
